/** GraphQL queries for @ah/music — used by desktop and mobile. */

const SONG_FIELDS = /* GraphQL */ `
  id
  title
  lyrics
  imageUrl
  variantAAudioUrl
  variantADurationSec
  variantBAudioUrl
  variantBDurationSec
  status
  readyAt
  createdAt
  artist {
    id
    slug
    name
    tagline
    style
  }
`;

export const LATEST_SONGS_QUERY = /* GraphQL */ `
  query LatestSongs($limit: Int) {
    latestSongs(limit: $limit) { ${SONG_FIELDS} }
  }
`;

export const RECOMMENDED_SONGS_QUERY = /* GraphQL */ `
  query RecommendedSongs($limit: Int) {
    recommendedSongs(limit: $limit) { ${SONG_FIELDS} }
  }
`;

export const SONG_DETAIL_QUERY = /* GraphQL */ `
  query SongDetail($id: ID!) {
    song(id: $id) {
      ${SONG_FIELDS}
      prompt
      isSaved
      artist {
        id
        slug
        name
        tagline
        bio
        style
        moodTags
      }
    }
  }
`;

export const RECENTLY_PLAYED_SONGS_QUERY = /* GraphQL */ `
  query RecentlyPlayedSongs($limit: Int) {
    recentlyPlayedSongs(limit: $limit) { ${SONG_FIELDS} }
  }
`;

export const SAVED_SONGS_QUERY = /* GraphQL */ `
  query SavedSongs($limit: Int) {
    savedSongs(limit: $limit) { ${SONG_FIELDS} }
  }
`;

export const RECORD_SONG_ENGAGEMENT_MUTATION = /* GraphQL */ `
  mutation RecordSongEngagement($id: ID!) {
    recordSongEngagement(id: $id)
  }
`;

export const RECORD_SONG_SAVE_MUTATION = /* GraphQL */ `
  mutation RecordSongSave($id: ID!) {
    recordSongSave(id: $id)
  }
`;

export const RECORD_SONG_UNSAVE_MUTATION = /* GraphQL */ `
  mutation RecordSongUnsave($id: ID!) {
    recordSongUnsave(id: $id)
  }
`;

export const MUSIC_ARTISTS_QUERY = /* GraphQL */ `
  query MusicArtists {
    musicArtists {
      id
      slug
      name
      tagline
      style
      songCount
    }
  }
`;

export const MUSIC_ARTIST_DETAIL_QUERY = /* GraphQL */ `
  query MusicArtistDetail($slug: String!) {
    musicArtist(slug: $slug) {
      id
      slug
      name
      tagline
      bio
      style
      moodTags
      songCount
      latestSongs(limit: 30) { ${SONG_FIELDS} }
    }
  }
`;
